import { render, staticRenderFns } from "./PlexHome.vue?vue&type=template&id=05735950&"
import script from "./PlexHome.vue?vue&type=script&lang=js&"
export * from "./PlexHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports